<template>
	<v-main>
		<div id="core-view">
			<v-fade-transition mode="out-in">
				<nuxt />
			</v-fade-transition>
		</div>
	</v-main>
</template>

<script>
export default {};
</script>

<style>
#core-view {
	padding-bottom: 100px;
	margin: 15px 20px;
}
</style>
